import apiClient from '../infrastructure/http/apiClient';
import appConfig from '../infrastructure/config/AppConfig';

/**
 * Servicio de métricas de órdenes
 * @module orderMetricsService
 */

/**
 * Obtiene métricas de órdenes desde el backend.
 * @param {Object} params
 * @param {string} [params.range="30d"] Rango de días (ej. "30d", "90d")
 * @param {string|number} [params.storeId] ID de la tienda
 * @returns {Promise<{ metrics: Array }>} Respuesta HTTP con array metrics
 */
export async function fetchOrderMetrics({ range = '30d', storeId } = {}) {
  const query = new URLSearchParams({ range });
  if (storeId) query.append('storeId', storeId);
  const url = `/metrics/orders?${query.toString()}`;
  return apiClient.get(url, {
    timeout: 10000,
  });
}

/**
 * Solicita recálculo de métricas de órdenes on-demand.
 * @param {string|number} storeId
 * @returns {Promise<{ processed: number }>} Resultado del recálculo
 */
export async function recalcOrderMetrics(storeId) {
  if (!storeId) throw new Error('storeId required');
  const url = '/metrics/orders/recalc';
  return apiClient.post(url, { storeId }, { timeout: 20000 });
}
